import type { BaseKeyFunction } from "../../../lib";

export const keySubscriptions: BaseKeyFunction = () => ["subscriptions"];

export const keySubscription: BaseKeyFunction = () => ["subscription"];
